import React, { useState } from "react";
import { Avatar, Divider } from "antd";
// import Image from "next/image";
import linkedInIcon from "images/icon-linkedin.svg";
import IconMail from "images/icon-mail-outline.svg";

// import { useRouter } from "next/router";
import "./style.scss";
import PopupSpeakerSummit from "../PopupInstructor";
import ChatMessageIcon from "../../../containers/ChatBox/ChatMessageIcon";
import { MessageOutlined } from "@ant-design/icons";
import { useChatMessageStore } from "../../../containers/ChatBox/store";

const CardUser = ({ instructor, title, btnClass = true, boxShadow = true, showChatIcon = false }) => {
  const [openModal, setOpenModal] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  // const { query } = useRouter();
  // const { name: slug } = query;

  const handleModalShowUser = async (visible = false, speaker = {}) => {
    setOpenModal(visible);
    setUserSelected(speaker);
  };

  const chatMessageStore = useChatMessageStore();

  const isOnline = chatMessageStore.onlineUsers.some(onlineUser => onlineUser.userId === instructor.UserId);

  const setShowMain = useChatMessageStore.getState().setShowMain;

  return (
    <div className={"card-user"} style={!boxShadow ? { boxShadow: "none", marginBottom: "60px", position: "relative" } : { position: "relative"}}>
      {(isOnline && showChatIcon) && (
        <div style={{
          position: "absolute",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "1rem"
        }}>
          <div
           style={{
             backgroundColor: "green",
             color: "white",
             padding: "2px 4px",
             borderRadius: "5px",
             width: "min-content"
           }}
          >
            Online
          </div>
        </div>
      )}
      <Avatar src={instructor?.User?.img || instructor?.img} className="avatar"></Avatar>
      <Divider className={"divider"} />
      <h3 className={"name"}>{`${instructor?.User?.firstName || instructor?.firstName} ${
        instructor?.User?.lastName || instructor?.lastName
      }`}</h3>
      <p style={{ fontSize: "15px" }}>{instructor?.User?.titleProfessions || instructor?.titleProfessions}</p>
      <p style={{ fontSize: "15px" }}>{instructor?.User?.company}</p>
      <p className={"text-content"}>{/* Co-Founder Hacking HR */}</p>

      <div
        className={"container"}
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <a
          href={instructor?.User?.personalLinks?.linkedin || instructor?.linkedin}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={"icon-linkedin"} src={linkedInIcon} alt="linkedin" />
        </a>
        <a href={`mailto:${instructor?.User?.email || instructor?.email}`}>
          <img
            src={IconMail}
            alt="email"
            style={{
              width: "2.4rem",
            }}
          />
        </a>
        {btnClass && (
          <p
            className={"classes-btn"}
            onClick={() => handleModalShowUser(true, instructor)}
          >
            Class
          </p>
        )}
        {showChatIcon && (
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setShowMain(true)

              chatMessageStore.setChatMessageWindows({
                img: instructor.img,
                name: `${instructor?.firstName || instructor?.User.firstName} ${instructor?.lastName || instructor?.User.lastName}`,
                id: instructor.UserId,
                titleProfessions: instructor.titleProfessions,
                type: "individual",
              });
            }}
          >
            <MessageOutlined style={{ fontSize: "1.75rem", color: "#697077" }} />
          </div>
        )}
      </div>
      {btnClass && (
        <>
          <PopupSpeakerSummit
            updatedEvent={{}}
            open={openModal}
            funModal={handleModalShowUser}
            speaker={userSelected}
            speakerId={userSelected?.id}
            certificateSlug={undefined}
          />
        </>
      )}
    </div>
  );
};

export default CardUser;
